import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import leftArrowIcon from '../assets/left.png';

// Shared design tokens (see src/pages/About.js for the full palette + rationale)
const displayFont = { fontFamily: "'Sora', ui-sans-serif, system-ui, sans-serif" };
const bodyFont = { fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" };
const monoFont = { fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace" };

const ClassificationModel = () => {
  const location = useLocation();
  const { result: initialResult, imageUrl: initialImageUrl } = location.state || {};
  const classificationResult = initialResult || null;
  const classifiedImageUrl = initialImageUrl || '';
  const hasResult = Boolean(classificationResult);

  useEffect(() => {
    if (!initialResult && !initialImageUrl) {
      // No result was passed in — nothing to load yet.
    }
  }, [initialResult, initialImageUrl]);

  return (
    <div className="flex flex-col min-h-screen bg-[#FAF9F6]" style={bodyFont}>
      {/* Top bar */}
      <div className="relative bg-white border-b border-[#E4E1D8]">
        <div className="container mx-auto px-4 md:px-8 py-4 flex items-center gap-4">
          <Link to="/diagnosis-model">
            <span className="flex items-center justify-center w-10 h-10 rounded-full bg-[#FAF9F6] border border-[#E4E1D8] shadow-sm hover:border-[#4FB3A9] transition-colors">
              <img src={leftArrowIcon} alt="Back" className="w-4 h-4" />
            </span>
          </Link>
          <div>
            <p className="text-[11px] tracking-wider text-[#0F3D3E]/60" style={monoFont}>
              AI DIAGNOSIS · IMAGE CLASSIFICATION
            </p>
            <h1 className="text-lg md:text-xl font-bold text-[#0F3D3E]" style={displayFont}>
              Classification Result
            </h1>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow flex flex-col items-center px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl border border-[#E4E1D8] shadow-sm w-full max-w-2xl overflow-hidden">
          {classifiedImageUrl ? (
            <div className="bg-[#0F3D3E]/5 p-4 md:p-6">
              <img
                src={classifiedImageUrl}
                alt="Classification input"
                className="w-full h-auto object-contain rounded-lg max-h-96 mx-auto border border-[#E4E1D8] shadow-sm bg-white"
              />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-14 px-6 bg-[#0F3D3E]/5 text-[#22262B]/50">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" className="mb-3 opacity-60">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" strokeWidth="1.5" />
                <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <p className="text-sm">No image was provided for this result.</p>
            </div>
          )}

          <div className="p-6 md:p-8 text-center">
            <p className="text-sm md:text-base font-medium text-[#22262B]/70 mb-3">
              The classification of this image is:
            </p>

            {hasResult ? (
              <div className="inline-flex items-center gap-3 border-l-4 border-[#D6A419] bg-[#FAF9F6] rounded-lg px-5 py-4">
                <span className="w-2.5 h-2.5 rounded-full bg-[#4FB3A9] shrink-0" />
                <h3
                  className="text-2xl md:text-3xl font-extrabold text-[#0F3D3E] text-left"
                  style={displayFont}
                >
                  {classificationResult}
                </h3>
              </div>
            ) : (
              <div className="inline-flex items-center gap-2 border-l-4 border-[#E4E1D8] bg-[#FAF9F6] rounded-lg px-5 py-4">
                <h3 className="text-lg font-semibold text-[#22262B]/50" style={displayFont}>
                  N/A
                </h3>
              </div>
            )}

            <div className="flex flex-col sm:flex-row justify-center gap-3 mt-8">
              <Link
                to="/diagnosis-model"
                className="bg-[#0F3D3E] hover:bg-[#0F3D3E]/90 text-white font-semibold py-2.5 px-6 rounded-md shadow-sm transition-colors duration-200"
              >
                Run New Scan
              </Link>
              <Link
                to="/home"
                className="bg-white hover:bg-[#FAF9F6] text-[#0F3D3E] font-semibold py-2.5 px-6 rounded-md border border-[#E4E1D8] transition-colors duration-200"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassificationModel;
